import './SliderProducts.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';
import { SwiperSlide } from 'swiper/react';

import { ProductTile } from '../ProductTile';
import { Slider } from './Slider';
import { SliderButton } from './SliderButton';

export interface SliderProductsProps {
  className?: string;
  numberSlidesLg?: number;
  products?: Array<b2x.ProductApiDto>;
  title?: string;
}

export const SliderProducts = ({ className, numberSlidesLg = 4, products, title }: SliderProductsProps) => {
  const sliderNextButton = React.useRef<HTMLButtonElement>(null);
  const sliderPrevButton = React.useRef<HTMLButtonElement>(null);

  return (
    <div className={classnames('slider-products mb-3 mb-lg-5', className)}>
      {title && (
        <div className="container-xxl">
          <div className="text-center mb-2">
            <h3 className="h2 text-blue">{title && b2x.formatHtml(title)}</h3>
          </div>
        </div>
      )}

      <div className={classnames('container-xxl p-lg-3', { 'pe-0': products && products.length > 1 })}>
        <b2x.EqualHeight>
          <div className="slider-container position-relative">
            <Slider
              navigation
              responsive={{
                lg: {
                  slidesPerView: numberSlidesLg,
                },
                md: {
                  slidesPerView: 2.2,
                },
              }}
              sliderNextEl={sliderNextButton}
              sliderPrevEl={sliderPrevButton}
              slidesPerView={products?.length === 1 ? 1 : 1.2}
              spaceBetween={20}
            >
              {products?.map((product) => (
                <SwiperSlide key={product.id}>
                  <ProductTile enableExtraInfo product={product} />
                </SwiperSlide>
              ))}
            </Slider>

            <SliderButton direction="left" innerRef={sliderPrevButton} size="small" />
            <SliderButton direction="right" innerRef={sliderNextButton} size="small" />
          </div>
        </b2x.EqualHeight>
      </div>
    </div>
  );
};
